export enum Clause {
    SELECT = 'SELECT',
    FROM = 'FROM',
    WHERE = 'WHERE',
    GROUP_BY = 'GROUP_BY',
    ORDER_BY = 'ORDER_BY'
}
